<script setup lang="ts">
import type { ActiveFilterChip } from '~/utils/filter/chips'

const openFilter = defineModel('openFilter', { default: false })

const { searchKeyword, numFound, sortFilter, selectedLegalArea, showOnlyFavorites, selectedAuthor } = useTemplateFilters()

const chips = computed<ActiveFilterChip[]>(() => {
  return [
    ...selectedLegalArea.value.map(option => ({
      key: `area:${option.value}`,
      label: option.label,
      remove: () => {
        selectedLegalArea.value = selectedLegalArea.value.filter(o => o.value !== option.value)
      },
    })),
  ...selectedAuthor.value.map(option => ({
      key: `author:${option.value}`,
      label: option.label,
      remove: () => {
        selectedAuthor.value = selectedAuthor.value.filter(o => o.value !== option.value)
      },
    })),
  ]
})
</script>

<template>
  <FilterListHeader
    v-model:search="searchKeyword"
    v-model:open-filter="openFilter"
    breakpoint="lg"
    :count="`${numFound} treff`"
    search-id="template-search-compact"
    search-label="Filtrer på tittel eller forfatter"
    search-placeholder="Søk etter mal"
    :chips="chips"
  >
    <template #actions>
      <FilterFavoritesChip v-model="showOnlyFavorites" breakpoint="lg" />
      <FilterSortSelect id="sort-templates" v-model="sortFilter" :options="TEMPLATES_SORTING_OPTIONS" />
    </template>

    <TemplatesMobileFilters v-model:open-filter="openFilter" />
  </FilterListHeader>
</template>
